import { LAPTOP_SCREEN_MQ } from "../constants/breakpoints";

export const matchLaptopMediaQuery = () => {
  return matchMedia(LAPTOP_SCREEN_MQ).matches;
};

export const isMatchingMediaQuery = (mediaQuery: string) => {
  return matchMedia(mediaQuery).matches;
};
